export const countryList = [
  {
    latitude: 33.93911,
    longitude: 67.709953,
    name: "Afghanistan",
    hint: "This country is relatively large & located in the Middle East",
    imageName: "afghanistan-flag.png"
  },
  {
    latitude: 41.153332,
    longitude: 20.168331,
    name: "Albania",
    hint: "This country is relatively small & located in Europe",
    imageName: "albania-flag.png"
  },
  {
    latitude: 28.033886,
    longitude: 1.659626,
    name: "Algeria",
    hint: "This is Africa's biggest country",
    imageName: "algeria-flag.png"
  },
  {
    latitude: 42.546245,
    longitude: 1.601554,
    name: "Andorra",
    hint: "This country is very small & located in Europe",
    imageName: "andorra-flag.png"
  },
  {
    latitude: -11.202692,
    longitude: 17.873887,
    name: "Angola",
    hint: "This country is relatively large & located in Africa",
    imageName: "angola-flag.png"
  },
  {
    latitude: 17.060816,
    longitude: -61.796428,
    name: "Antigua and Barbuda",
    hint: "This country is two islands & located in the caribbean",
    imageName: "antigua_and_barbuda.png"
  },
  {
    latitude: -38.416097,
    longitude: -63.616672,
    name: "Argentina",
    hint: "This country is large & located in South America",
    imageName: "argentina-flag.png"
  },
  {
    latitude: 40.069099,
    longitude: 45.038189,
    name: "Armenia",
    hint: "This country is small & located in the Middle East",
    imageName: "armenia-flag.png"
  },
  {
    latitude: -25.274398,
    longitude: 133.775136,
    name: "Australia",
    hint: "This country is very large & located in Oceania",
    imageName: "australia-flag.png"
  },
  {
    latitude: 47.516231,
    longitude: 14.550072,
    name: "Austria",
    hint: "This country is relatively small & located in Europe",
    imageName: "austria-flag.png"
  },
  {
    latitude: 40.143105,
    longitude: 47.576927,
    name: "Azerbaijan",
    hint: "This country is small & located in the Middle East",
    imageName: "azerbaijan-flag.png"
  },
  {
    latitude: 25.03428,
    longitude: -77.39628,
    name: "Bahamas",
    hint: "This country consists of hundreds of islands & it is located in the caribbean",
    imageName: "bahamas-flag.png"
  },
  {
    latitude: 25.930414,
    longitude: 50.637772,
    name: "Bahrain",
    hint: "This country is very small & it is located in the Middle East",
    imageName: "bahrain-flag.png"
  },
  {
    latitude: 23.684994,
    longitude: 90.356331,
    name: "Bangladesh",
    hint: "This country is relatively small & it is located in Asia",
    imageName: "bangladesh-flag.png"
  },
  {
    latitude: 13.193887,
    longitude: -59.543198,
    name: "Barbados",
    hint: "This country is an island in the caribbean",
    imageName: "barbados-flag.png"
  },
  {
    latitude: 53.709807,
    longitude: 27.953389,
    name: "Belarus",
    hint: "This country is large & it is located in Europe",
    imageName: "belarus-flag.png"
  },
  {
    latitude: 50.503887,
    longitude: 4.469936,
    name: "Belgium",
    hint: "This country is relatively small & it is located in Europe",
    imageName: "belgium-flag.png"
  },
  {
    latitude: 17.189877,
    longitude: -88.49765,
    name: "Belize",
    hint: "This country is small & it is located in Central America",
    imageName: "belize-flag.png"
  },
  {
    latitude: 9.30769,
    longitude: 2.315834,
    name: "Benin",
    hint: "This country is small & it is located in Africa",
    imageName: "benin-flag.png"
  },
  {
    latitude: 27.514162,
    longitude: 90.433601,
    name: "Bhutan",
    hint: "This country is very small & it is located in Asia",
    imageName: "bhutan-flag.png"
  },
  {
    latitude: -16.290154,
    longitude: -63.588653,
    name: "Bolivia",
    hint: "This country is relatively big & it is located in South America",
    imageName: "bolivia-flag.png"
  },
  {
    latitude: 43.915886,
    longitude: 17.679076,
    name: "Bosnia and Herzegovina",
    hint: "This country is small & it is located in Asia",
    imageName: "bosnia_and_herzegovina-flag.png"
  },
  {
    latitude: -22.328474,
    longitude: 24.684866,
    name: "Botswana",
    hint: "This country is relatively large & it is located in Africa",
    imageName: "botswana-flag.png"
  },
  {
    latitude: -14.235004,
    longitude: -51.92528,
    name: "Brazil",
    hint: "This country is the largest country in South America",
    imageName: "brazil-flag.png"
  },
  {
    latitude: 4.535277,
    longitude: 114.727669,
    name: "Brunei",
    hint: "This country is very small & is located in Asia",
    imageName: "brunei-flag.png"
  },
  {
    latitude: 42.733883,
    longitude: 25.48583,
    name: "Bulgaria",
    hint: "This country is relatively small & it is located in Europe",
    imageName: "bulgaria-flag.png"
  },
  {
    latitude: 12.238333,
    longitude: -1.561593,
    name: "Burkina Faso",
    hint: "This country is quite small & it is located in Africa",
    imageName: "burkina_faso-flag.png"
  },
  {
    latitude: -3.373056,
    longitude: 29.918886,
    name: "Burundi",
    hint: "This country is very small & it is located in Africa",
    imageName: "burundi-flag.png"
  },
  {
    latitude: 12.565679,
    longitude: 104.990963,
    name: "Cambodia",
    hint: "This country is relatively small & it is located in Asia",
    imageName: "cambodia-flag.png"
  },
  {
    latitude: 7.369722,
    longitude: 12.354722,
    name: "Cameroon",
    hint: "This country is relatively small & it is located in Africa",
    imageName: "cameroon-flag.png"
  },
  {
    latitude: 56.130366,
    longitude: -106.346771,
    name: "Canada",
    hint: "This flag's country is large & located in North America",
    imageName: "canada-flag.png"
  },
  {
    latitude: 16.002082,
    longitude: -24.013197,
    name: "Cape Verde",
    hint: "This is an island country off the coast of Africa",
    imageName: "cape_verde-flag.png"
  },
  {
    latitude: 6.611111,
    longitude: 20.939444,
    name: "Central African Republic",
    hint: "This country is relatively small & it is located in Africa",
    imageName: "central_african_republic-flag.png"
  },
  {
    latitude: 15.454166,
    longitude: 18.732207,
    name: "Chad",
    hint: "This country is relatively large & it is located in Africa",
    imageName: "chad-flag.png"
  },
  {
    latitude: -35.675147,
    longitude: -71.542969,
    name: "Chile",
    hint: "This country is relatively large & it is located in South America",
    imageName: "chile-flag.png"
  },
  {
    latitude: 35.86166,
    longitude: 104.195397,
    name: "China",
    hint: "This country is very large & it is located in Asia",
    imageName: "china-flag.png"
  },
  {
    latitude: 4.570868,
    longitude: -74.297333,
    name: "Colombia",
    hint: "This country is relatively large & it is located in South America",
    imageName: "colombia-flag.png"
  },
  {
    latitude: -11.875001,
    longitude: 43.872219,
    name: "Comoros",
    hint: "This country is an archipelago off the coast of Africa",
    imageName: "comoros-flag.png"
  },
  {
    latitude: -0.228021,
    longitude: 15.827659,
    name: "Congo",
    hint: "This country is relatively small & it is located in Africa",
    imageName: "congo-flag.png"
  },
  {
    latitude: 9.748917,
    longitude: -83.753428,
    name: "Costa Rica",
    hint: "This country is small & it is located in Central America",
    imageName: "costa_rica-flag.png"
  },
  {
    latitude: 45.1,
    longitude: 15.2,
    name: "Croatia",
    hint: "This country is relatively small & it is located in Europe",
    imageName: "croatia-flag.png"
  },
  {
    latitude: 21.521757,
    longitude: -77.781167,
    name: "Cuba",
    hint: "This country is relatively large & in the caribbean",
    imageName: "cuba-flag.png"
  },
  {
    latitude: 35.126413,
    longitude: 33.429859,
    name: "Cyprus",
    hint: "This country is a small island in Europe",
    imageName: "cyprus-flag.png"
  },
  {
    latitude: 49.817492,
    longitude: 15.472962,
    name: "Czechia",
    hint: "This country is relatively small & it is located in Europe",
    imageName: "czechia-flag.png"
  },
  {
    latitude: -4.038333,
    longitude: 21.758664,
    name: "Democratic Republic of the Congo",
    hint: "This country is large & it is located in Africa",
    imageName: "democratic_republic_of_the_congo-flag.png"
  },
  {
    latitude: 56.26392,
    longitude: 9.501785,
    name: "Denmark",
    hint: "This country is relatively small & it is located in Europe",
    imageName: "denmark-flag.png"
  },
  {
    latitude: 11.825138,
    longitude: 42.590275,
    name: "Djibouti",
    hint: "This country is very small & it is located in Africa",
    imageName: "djibouti-flag.png"
  },
  {
    latitude: 15.414999,
    longitude: -61.370976,
    name: "Dominica",
    hint: "This is a small island country in the caribbean",
    imageName: "dominica-flag.png"
  },
  {
    latitude: 18.735693,
    longitude: -70.162651,
    name: "Dominican Republic",
    hint: "This is a relatively small island country located in the caribbean",
    imageName: "dominican_republic-flag.png"
  },
  {
    latitude: -1.831239,
    longitude: -78.183406,
    name: "Ecuador",
    hint: "This country is relatively small & it is located in South America",
    imageName: "ecuador-flag.png"
  },
  {
    latitude: 26.820553,
    longitude: 30.802498,
    name: "Egypt",
    hint: "This country is relatively large & it is located in Africa",
    imageName: "egypt-flag.png"
  },
  {
    latitude: 13.794185,
    longitude: -88.89653,
    name: "El Salvador",
    hint: "This country is very small & it is located in Central America",
    imageName: "el_salvador-flag.png"
  },
  {
    latitude: 1.650801,
    longitude: 10.267895,
    name: "Equatorial Guinea",
    hint: "This country is very small & it is located in Africa",
    imageName: "equatorial_guinea-flag.png"
  },
  {
    latitude: 15.179384,
    longitude: 39.782334,
    name: "Eritrea",
    hint: "This country is small & it is located in Africa",
    imageName: "eritrea-flag.png"
  },
  {
    latitude: 58.595272,
    longitude: 25.013607,
    name: "Estonia",
    hint: "This country is relatively small & it is located in Europe",
    imageName: "estonia-flag.png"
  },
  {
    latitude: -26.522503,
    longitude: 31.465866,
    name: "Eswatini",
    hint: "This country is very small & it is located in Africa",
    imageName: "eswatini-flag.png"
  },
  {
    latitude: 9.145,
    longitude: 40.489673,
    name: "Ethiopia",
    hint: "This country is relatively large & it is located in Africa",
    imageName: "ethiopia-flag.png"
  },
  {
    latitude: -16.578193,
    longitude: 179.414413,
    name: "Fiji",
    hint: "This is a small island country in Oceania",
    imageName: "fiji-flag.png"
  },
  {
    latitude: 61.92411,
    longitude: 25.748151,
    name: "Finland",
    hint: "This country is relatively large & it is located in Europe",
    imageName: "finland-flag.png"
  },
  {
    latitude: 46.227638,
    longitude: 2.213749,
    name: "France",
    hint: "This country is relatively large & it is located in Europe",
    imageName: "france-flag.png"
  },
  {
    latitude: -0.803689,
    longitude: 11.609444,
    name: "Gabon",
    hint: "This country is relatively small & it is located in Africa",
    imageName: "gabon-flag.png"
  },
  {
    latitude: 13.443182,
    longitude: -15.310139,
    name: "Gambia",
    hint: "This country is very small & it is located in Africa",
    imageName: "gambia-flag.png"
  },
  {
    latitude: 42.315407,
    longitude: 43.356892,
    name: "Georgia",
    hint: "This country is small & it is located in the Middle East",
    imageName: "georgia-flag.png"
  },
  {
    latitude: 51.165691,
    longitude: 10.451526,
    name: "Germany",
    hint: "This country is relatively large & it is located in Europe",
    imageName: "germany-flag.png"
  },
  {
    latitude: 7.946527,
    longitude: -1.023194,
    name: "Ghana",
    hint: "This country is relatively small & it is located in Africa",
    imageName: "ghana-flag.png"
  },
  {
    latitude: 39.074208,
    longitude: 21.824312,
    name: "Greece",
    hint: "This country contains many islands & it is in Europe",
    imageName: "greece-flag.png"
  },
  {
    latitude: 12.262776,
    longitude: -61.604171,
    name: "Grenada",
    hint: "This country is a very small island in the caribbean",
    imageName: "grenada-flag.png"
  },
  {
    latitude: 15.783471,
    longitude: -90.230759,
    name: "Guatemala",
    hint: "This country is relatively small & it is located in Central America",
    imageName: "guatemala-flag.png"
  },
  {
    latitude: 9.945587,
    longitude: -9.696645,
    name: "Guinea",
    hint: "",
    imageName: "guinea-flag.png"
  },
  {
    latitude: 11.803749,
    longitude: -15.180413,
    name: "Guinea-Bissau",
    hint: "This country is relatively small & it is located in Africa",
    imageName: "guinea_bissau-flag.png"
  },
  {
    latitude: 4.860416,
    longitude: -58.93018,
    name: "Guyana",
    hint: "This country is small & it is located in South America",
    imageName: "guyana-flag.png"
  },
  {
    latitude: 18.971187,
    longitude: -72.285215,
    name: "Haiti",
    hint: "This is a small country in the caribbean",
    imageName: "haiti-flag.png"
  },
  {
    latitude: 15.199999,
    longitude: -86.241905,
    name: "Honduras",
    hint: "This is a relatively small country & it is in Central America",
    imageName: "honduras-flag.png"
  },
  {
    latitude: 47.162494,
    longitude: 19.503304,
    name: "Hungary",
    hint: "This country is relatively small & it is located in Europe",
    imageName: "hungary-flag.png"
  },
  {
    latitude: 64.963051,
    longitude: -19.020835,
    name: "Iceland",
    hint: "This country is a Nordic Island nation",
    imageName: "iceland-flag.png"
  },
  {
    latitude: 20.593684,
    longitude: 78.96288,
    name: "India",
    hint: "This country is large & it is located in Asia",
    imageName: "india-flag.png"
  },
  {
    latitude: -0.789275,
    longitude: 113.921327,
    name: "Indonesia",
    hint: "This country is relatively large & it is located in Asia",
    imageName: "indonesia-flag.png"
  },
  {
    latitude: 33.223191,
    longitude: 43.679291,
    name: "Iraq",
    hint: "This country is relatively large & it is located in the Middle East",
    imageName: "iraq-flag.png"
  },
  {
    latitude: 32.427908,
    longitude: 53.688046,
    name: "Iran",
    hint: "This country is large & it is located in the Middle East",
    imageName: "iran-flag.png"
  },
  {
    latitude: 53.41291,
    longitude: -8.24389,
    name: "Ireland",
    hint: "This country is relatively small & it is located in Europe",
    imageName: "ireland-flag.png"
  },
  {
    latitude: 31.046051,
    longitude: 34.851612,
    name: "Israel",
    hint: "This country is very small & it is located in the Middle East",
    imageName: "israel-flag.png"
  },
  {
    latitude: 41.87194,
    longitude: 12.56738,
    name: "Italy",
    hint: "this country is relatively large & it is located in Europe",
    imageName: "italy-flag.png"
  },
  {
    latitude: 7.539989,
    longitude: -5.54708,
    name: "Ivory Coast (Cote d'Ivoire)",
    hint: "This country is relatively small & it is located in Africa",
    imageName: "ivory_coast-flag.png"
  },
  {
    latitude: 18.109581,
    longitude: -77.297508,
    name: "Jamaica",
    hint: "This country is a small island in the caribbean",
    imageName: "jamaica-flag.png"
  },
  {
    latitude: 36.204824,
    longitude: 138.252924,
    name: "Japan",
    hint: "This country is relatively large & it is located in Asia",
    imageName: "japan-flag.png"
  },
  {
    latitude: 30.585164,
    longitude: 36.238414,
    name: "Jordan",
    hint: "This country is small & it is located in the Middle East",
    imageName: "jordan-flag.png"
  },
  {
    latitude: 48.019573,
    longitude: 66.923684,
    name: "Kazakhstan",
    hint: "This country is very large & it is located in Asia",
    imageName: "kazakhstan-flag.png"
  },
  {
    latitude: -0.023559,
    longitude: 37.906193,
    name: "Kenya",
    hint: "This country is relatively small & it is located in Africa",
    imageName: "kenya-flag.png"
  },
  {
    latitude: -3.370417,
    longitude: -168.734039,
    name: "Kiribati",
    hint: "This is a small island country located in Oceania",
    imageName: "kiribati-flag.png"
  },
  {
    latitude: 29.31166,
    longitude: 47.481766,
    name: "Kuwait",
    hint: "This is a very small country & it is located in the Middle East",
    imageName: "kuwait-flag.png"
  },
  {
    latitude: 41.20438,
    longitude: 74.766098,
    name: "Kyrgyzstan",
    hint: "This country is relatively large & it is located in Asia",
    imageName: "kyrgyzstan-flag.png"
  },
  {
    latitude: 19.85627,
    longitude: 102.495496,
    name: "Laos",
    hint: "This is a relatively small country & it is located in Asia",
    imageName: "laos-flag.png"
  },
  {
    latitude: 56.879635,
    longitude: 24.603189,
    name: "Latvia",
    hint: "This country is relatively small & it is located in Europe",
    imageName: "latvia-flag.png"
  },
  {
    latitude: 33.854721,
    longitude: 35.862285,
    name: "Lebanon",
    hint: "This country is very small & it is located in the Middle East",
    imageName: "lebanon-flag.png"
  },
  {
    latitude: -29.609988,
    longitude: 28.233608,
    name: "Lesotho",
    hint: "This country is very small & it is located in Africa",
    imageName: "lesotho-flag.png"
  },
  {
    latitude: 6.428055,
    longitude: -9.429499,
    name: "Liberia",
    hint: "This country is small & it is located in Africa",
    imageName: "liberia-flag.png"
  },
  {
    latitude: 26.3351,
    longitude: 17.228331,
    name: "Libya",
    hint: "This country is relatively large & it is located in Africa",
    imageName: "libya-flag.png"
  },
  {
    latitude: 47.166,
    longitude: 9.555373,
    name: "Liechtenstein",
    hint: "This country is very small & it is located in Europe",
    imageName: "liechtenstein-flag.png"
  },
  {
    latitude: 55.169438,
    longitude: 23.881275,
    name: "Lithuania",
    hint: "This country is relatively small & it is located in Europe",
    imageName: "lithuania-flag.png"
  },
  {
    latitude: 49.815273,
    longitude: 6.129583,
    name: "Luxembourg",
    hint: "This country is very small & it is located in Europe",
    imageName: "luxembourg-flag.png"
  },
  {
    latitude: -18.766947,
    longitude: 46.869107,
    name: "Madagascar",
    hint: "This is an island country off the coast of Africa",
    imageName: "madagascar-flag.png"
  },
  {
    latitude: -13.254308,
    longitude: 34.301525,
    name: "Malawi",
    hint: "This country is small & it is located in Africa",
    imageName: "malawi-flag.png"
  },
  {
    latitude: 4.040255,
    longitude: 109.091912,
    name: "Malaysia",
    hint: "This country is relatively large & it is located in Asia",
    imageName: "malaysia-flag.png"
  },
  {
    latitude: 3.202778,
    longitude: 73.22068,
    name: "Maldives",
    hint: "This country consists of serveral islands & it is located off the coast of Asia",
    imageName: "maldives-flag.png"
  },
  {
    latitude: 17.570692,
    longitude: -3.996166,
    name: "Mali",
    hint: "This country is large & it is located in Africa",
    imageName: "mali-flag.png"
  },
  {
    latitude: 35.937496,
    longitude: 14.375416,
    name: "Malta",
    hint: "This country is an archipelago off the coast of Europe",
    imageName: "malta-flag.png"
  },
  {
    latitude: 7.131474,
    longitude: 171.184478,
    name: "Marshall Islands",
    hint: "This country is a set of islands in Oceania",
    imageName: "marshall_islands-flag.png"
  },
  {
    latitude: 21.00789,
    longitude: -10.940835,
    name: "Mauritania",
    hint: "This country is large & it is located in Africa",
    imageName: "mauritania-flag.png"
  },
  {
    latitude: -20.348404,
    longitude: 57.552152,
    name: "Mauritius",
    hint: "This country is an island off the coast of Africa",
    imageName: "mauritius-flag.png"
  },
  {
    latitude: 23.634501,
    longitude: -102.552784,
    name: "Mexico",
    hint: "This country is large & located in North America",
    imageName: "mexico-flag.png"
  },
  {
    latitude: 7.425554,
    longitude: 150.550812,
    name: "Micronesia",
    hint: "This country is a set of islands in Oceania",
    imageName: "micronesia-flag.png"
  },
  {
    latitude: 47.411631,
    longitude: 28.369885,
    name: "Moldova",
    hint: "This country is small & it is located in Europe",
    imageName: "moldova-flag.png"
  },
  {
    latitude: 43.750298,
    longitude: 7.412841,
    name: "Monaco",
    hint: "This country is very small & it is located in Europe",
    imageName: "monaco-flag.png"
  },
  {
    latitude: 46.862496,
    longitude: 103.846656,
    name: "Mongolia",
    hint: "This country is large & it is located in Asia",
    imageName: "mongolia-flag.png"
  },
  {
    latitude: 42.708678,
    longitude: 19.37439,
    name: "Montenegro",
    hint: "This country is small & it is located in Europe",
    imageName: "montenegro-flag.png"
  },
  {
    latitude: 31.791702,
    longitude: -7.09262,
    name: "Morocco",
    hint: "This country is relatively small & it is located in Africa",
    imageName: "morocco-flag.png"
  },
  {
    latitude: -18.665695,
    longitude: 35.529562,
    name: "Mozambique",
    hint: "This country is relatively large & it is located in Africa",
    imageName: "mozambique-flag.png"
  },
  {
    latitude: 21.913965,
    longitude: 95.956223,
    name: "Myanmar (Burma)",
    hint: "This country is relatively large & it is located in Asia",
    imageName: "myanmar-flag.png"
  },
  {
    latitude: -22.95764,
    longitude: 18.49041,
    name: "Namibia",
    hint: "This country is relatively large & it is located in Africa",
    imageName: "namibia-flag.png"
  },
  {
    latitude: -0.522778,
    longitude: 166.931503,
    name: "Nauru",
    hint: "This country is a very small island in Oceania",
    imageName: "nauru-flag.png"
  },
  {
    latitude: 28.394857,
    longitude: 84.124008,
    name: "Nepal",
    hint: "This country is small & it is located in Asia",
    imageName: "nepal-flag.png"
  },
  {
    latitude: 52.132633,
    longitude: 5.291266,
    name: "Netherlands",
    hint: "This country is small & it is located in Europe",
    imageName: "netherlands-flag.png"
  },
  {
    latitude: -40.900557,
    longitude: 174.885971,
    name: "New Zealand",
    hint: "This country is relatively small & it is located in Oceania",
    imageName: "new_zealand-flag.png"
  },
  {
    latitude: 12.865416,
    longitude: -85.207229,
    name: "Nicaragua",
    hint: "This country is small & it is located in Central America",
    imageName: "nicaragua-flag.png"
  },
  {
    latitude: 17.607789,
    longitude: 8.081666,
    name: "Niger",
    hint: "This country is relatively large & it is located in Africa",
    imageName: "niger-flag.png"
  },
  {
    latitude: 9.081999,
    longitude: 8.675277,
    name: "Nigeria",
    hint: "This country is relatively large & it is located in Africa",
    imageName: "nigeria-flag.png"
  },
  {
    latitude: 40.339852,
    longitude: 127.510093,
    name: "North Korea",
    hint: "This country is small & it is located in Asia",
    imageName: "north_korea-flag.png"
  },
  {
    latitude: 41.608635,
    longitude: 21.745275,
    name: "North Macedonia",
    hint: "This country is very small & it is located in Europe",
    imageName: "north_macedonia-flag.png"
  },
  {
    latitude: 60.472024,
    longitude: 8.468946,
    name: "Norway",
    hint: "This country is fairly large & located in Europe",
    imageName: "norway-flag.png"
  },
  {
    latitude: 21.512583,
    longitude: 55.923255,
    name: "Oman",
    hint: "This country is relatively large & it is located in the Middle East",
    imageName: "oman-flag.png"
  },
  {
    latitude: 30.375321,
    longitude: 69.345116,
    name: "Pakistan",
    hint: "This country is relatively large & it is located in Asia",
    imageName: "pakistan-flag.png"
  },
  {
    latitude: 7.51498,
    longitude: 134.58252,
    name: "Palau",
    hint: "This country is a small island in Oceania",
    imageName: "palau-flag.png"
  },
  {
    latitude: 31.952162,
    longitude: 35.233154,
    name: "Palestine",
    hint: "This is a very small country in the Middle East",
    imageName: "palestine-flag.png"
  },
  {
    latitude: 8.537981,
    longitude: -80.782127,
    name: "Panama",
    hint: "This is a small country in Central America",
    imageName: "panama-flag.png"
  },
  {
    latitude: -6.314993,
    longitude: 143.95555,
    name: "Papua New Guinea",
    hint: "This is a relatively large country located in Oceania",
    imageName: "papua_new_guinea-flag.png"
  },
  {
    latitude: -23.442503,
    longitude: -58.443832,
    name: "Paraguay",
    hint: "This country is relatively small & it is located in South America",
    imageName: "paraguay-flag.png"
  },
  {
    latitude: -9.189967,
    longitude: -75.015152,
    name: "Peru",
    hint: "This country is relatively large & it is located in South America",
    imageName: "peru-flag.png"
  },
  {
    latitude: 12.879721,
    longitude: 121.774017,
    name: "Philippines",
    hint: "This country is relatively small & it is located in Asia",
    imageName: "philippines-flag.png"
  },
  {
    latitude: 51.919438,
    longitude: 19.145136,
    name: "Poland",
    hint: "This country is relatively large & it is located in Europe",
    imageName: "poland-flag.png"
  },
  {
    latitude: 39.399872,
    longitude: -8.224454,
    name: "Portugal",
    hint: "This country is relatively small & it is located in Europe",
    imageName: "portugal-flag.png"
  },
  {
    latitude: 25.354826,
    longitude: 51.183884,
    name: "Qatar",
    hint: "This country is very small & it is located in the Middle East",
    imageName: "qatar-flag.png"
  },
  {
    latitude: 45.943161,
    longitude: 24.96676,
    name: "Romania",
    hint: "This country is relatively large & it is located in Europe",
    imageName: "romania-flag.png"
  },
  {
    latitude: 61.52401,
    longitude: 105.318756,
    name: "Russia",
    hint: "This country is the largest in the world",
    imageName: "russia-flag.png"
  },
  {
    latitude: -1.940278,
    longitude: 29.873888,
    name: "Rwanda",
    hint: "This country is very small & it is located in Africa",
    imageName: "rwanda-flag.png"
  },
  {
    latitude: 17.357822,
    longitude: -62.782998,
    name: "Saint Kitts and Nevis",
    hint: "This country consists of 2 islands & it is located in the caribbean",
    imageName: "saint_kitts_and_nevis-flag.png"
  },
  {
    latitude: 13.909444,
    longitude: -60.978893,
    name: "Saint Lucia",
    hint: "This country is an island located in the caribbean",
    imageName: "saint_lucia-flag.png"
  },
  {
    latitude: 12.984305,
    longitude: -61.287228,
    name: "Saint Vincent and the Grenadines",
    hint: "This country is an island located in the caribbean",
    imageName: "saint_vincent_and_the_grenadines-flag.png"
  },
  {
    latitude: -13.759029,
    longitude: -172.104629,
    name: "Samoa",
    hint: "This country consists of several islands & it is located in Oceania",
    imageName: "samoa-flag.png"
  },
  {
    latitude: 43.94236,
    longitude: 12.457777,
    name: "San Marino",
    hint: "This country is very small & it is located in Europe",
    imageName: "san_marino-flag.png"
  },
  {
    latitude: 0.18636,
    longitude: 6.613081,
    name: "Sao Tome and Principe",
    hint: "This country is 2 islands off the coast of Africa",
    imageName: "sao_tome_and_principe-flag.png"
  },
  {
    latitude: 23.885942,
    longitude: 45.079162,
    name: "Saudi Arabia",
    hint: "This country is large & it is located in the Middle East",
    imageName: "saudi_arabia-flag.png"
  },
  {
    latitude: 14.497401,
    longitude: -14.452362,
    name: "Senegal",
    hint: "This country is small & it is located in Africa",
    imageName: "senegal-flag.png"
  },
  {
    latitude: 44.016521,
    longitude: 21.005859,
    name: "Serbia",
    hint: "This country is relatively small & it is located in Europe",
    imageName: "serbia-flag.png"
  },
  {
    latitude: -4.679574,
    longitude: 55.491977,
    name: "Seychelles",
    hint: "This country consists of over 100 islands & it is located off the coast of Africa",
    imageName: "seychelles-flag.png"
  },
  {
    latitude: 8.460555,
    longitude: -11.779889,
    name: "Sierra Leone",
    hint: "This country is small & it is located in Africa",
    imageName: "sierra_leone-flag.png"
  },
  {
    latitude: 1.352083,
    longitude: 103.819836,
    name: "Singapore",
    hint: "This country is very small & it is located in Asia",
    imageName: "singapore-flag.png"
  },
  {
    latitude: 48.669026,
    longitude: 19.699024,
    name: "Slovakia",
    hint: "This country is relatively small & it is located in Europe",
    imageName: "slovakia-flag.png"
  },
  {
    latitude: 46.151241,
    longitude: 14.995463,
    name: "Slovenia",
    hint: "This country is small & it is located in Europe",
    imageName: "slovenia-flag.png"
  },
  {
    latitude: -9.64571,
    longitude: 160.156194,
    name: "Solomon Islands",
    hint: "This country consists of over 100 islands & it is located in Oceania",
    imageName: "soloman_islands-flag.png"
  },
  {
    latitude: 5.152149,
    longitude: 46.199616,
    name: "Somalia",
    hint: "This country is relatively small & it is located in Africa",
    imageName: "somalia-flag.png"
  },
  {
    latitude: -30.559482,
    longitude: 22.937506,
    name: "South Africa",
    hint: "This country is relatively large & it is located in Africa",
    imageName: "south_africa-flag.png"
  },
  {
    latitude: 35.907757,
    longitude: 127.766922,
    name: "South Korea",
    hint: "This country is small & it is located in Asia",
    imageName: "south_korea-flag.png"
  },
  {
    latitude: 6.85065,
    longitude: 30.659016,
    name: "South Sudan",
    hint: "This country is relatively small & it is located in Africa",
    imageName: "south_sudan-flag.png"
  },
  {
    latitude: 40.463667,
    longitude: -3.74922,
    name: "Spain",
    hint: "This country is relatively large & it is locaetd in Europe",
    imageName: "spain-flag.png"
  },
  {
    latitude: 7.873054,
    longitude: 80.771797,
    name: "Sri Lanka",
    hint: "This country is an island off the coast of Asia",
    imageName: "sri_lanka-flag.png"
  },
  {
    latitude: 15.8905231,
    longitude: 30.7671933,
    name: "Sudan",
    hint: "This is a large country located in Africa",
    imageName: "sudan-flag.png"
  },
  {
    latitude: 3.919305,
    longitude: -56.027783,
    name: "Suriname",
    hint: "This country is small & it is located in South America",
    imageName: "suriname-flag.png"
  },
  {
    latitude: 60.128161,
    longitude: 18.643501,
    name: "Sweden",
    hint: "This country is fairly large & located in Europe",
    imageName: "sweden-flag.png"
  },
  {
    latitude: 46.818188,
    longitude: 8.227512,
    name: "Switzerland",
    hint: "This country is small & it is located in Europe",
    imageName: "switzerland-flag.png"
  },
  {
    latitude: 34.802075,
    longitude: 38.996815,
    name: "Syria",
    hint: "This country is relatively small & it is located in the Middle East",
    imageName: "syria-flag.png"
  },
  {
    latitude: 38.861034,
    longitude: 71.276093,
    name: "Tajikistan",
    hint: "This country is relatively small & it is located in Asia",
    imageName: "tajikistan-flag.png"
  },
  {
    latitude: -6.369028,
    longitude: 34.888822,
    name: "Tanzania",
    hint: "This country is relatively large & it is located in Africa",
    imageName: "tanzania-flag.png"
  },
  {
    latitude: 15.870032,
    longitude: 100.992541,
    name: "Thailand",
    hint: "This country is relatively large & it is located in Asia",
    imageName: "thailand-flag.png"
  },
  {
    latitude: -8.874217,
    longitude: 125.727539,
    name: "Timor-Leste (East Timor)",
    hint: "This country is small & it is located in Asia",
    imageName: "east_timor-flag.png"
  },
  {
    latitude: 8.619543,
    longitude: 0.824782,
    name: "Togo",
    hint: "This country is small & it is located in Africa",
    imageName: "togo-flag.png"
  },
  {
    latitude: -21.178986,
    longitude: -175.198242,
    name: "Tonga",
    hint: "This country consists of over 100 islands & it is located in Oceania",
    imageName: "tonga-flag.png"
  },
  {
    latitude: 10.691803,
    longitude: -61.222503,
    name: "Trinidad and Tobago",
    hint: "This country consists of 2 islands & it is located in the caribbean",
    imageName: "trinidad_and_tobago-flag.png"
  },
  {
    latitude: 33.886917,
    longitude: 9.537499,
    name: "Tunisia",
    hint: "This country is relatively small & it is located in Africa",
    imageName: "tunisia-flag.png"
  },
  {
    latitude: 38.963745,
    longitude: 35.243322,
    name: "Turkey",
    hint: "This country is relatively large & it is located in the Middle East",
    imageName: "turkey-flag.png"
  },
  {
    latitude: 38.969719,
    longitude: 59.556278,
    name: "Turkmenistan",
    hint: "This country is relatively large & it is located in Asia",
    imageName: "turkmenistan-flag.png"
  },
  {
    latitude: -7.109535,
    longitude: 177.64933,
    name: "Tuvalu",
    hint: "This country consists of several islands & it is located in Oceania",
    imageName: "tuvalu-flag.png"
  },
  {
    latitude: 1.373333,
    longitude: 32.290275,
    name: "Uganda",
    hint: "This country is small & it is located in Africa",
    imageName: "uganda-flag.png"
  },
  {
    latitude: 48.379433,
    longitude: 31.16558,
    name: "Ukraine",
    hint: "This country is large & it is located in Europe",
    imageName: "ukraine-flag.png"
  },
  {
    latitude: 23.424076,
    longitude: 53.847818,
    name: "United Arab Emirates",
    hint: "This country is small & it is located in the Middle East",
    imageName: "united_arab_emirates-flag.png"
  },
  {
    latitude: 55.378051,
    longitude: -3.435973,
    name: "United Kingdom",
    hint: "This country is relatively large & it is located in Europe",
    imageName: "united_kingdom-flag.png"
  },
  {
    latitude: 37.09024,
    longitude: -95.712891,
    name: "United States",
    hint: "This country is large & it is located in North America",
    imageName: "united_states-flag.png"
  },
  {
    latitude: -32.522779,
    longitude: -55.765835,
    name: "Uruguay",
    hint: "This country is relatively small & it is located in South America",
    imageName: "uruguay-flag.png"
  },
  {
    latitude: 41.377491,
    longitude: 64.585262,
    name: "Uzbekistan",
    hint: "This country is relatively large & it is located in Asia",
    imageName: "uzbekistan-flag.png"
  },
  {
    latitude: -15.376706,
    longitude: 166.959158,
    name: "Vanuatu",
    hint: "This country contains around 80 islands & it is located in Oceania",
    imageName: "vanuatu-flag.png"
  },
  {
    latitude: 41.902916,
    longitude: 12.453389,
    name: "Vatican City",
    hint: "This country is the smallest in the world",
    imageName: "vatican_city-flag.png"
  },
  {
    latitude: 6.42375,
    longitude: -66.58973,
    name: "Venezuela",
    hint: "This country is relatively small & it is located in South America",
    imageName: "venezuela-flag.png"
  },
  {
    latitude: 14.058324,
    longitude: 108.277199,
    name: "Vietnam",
    hint: "This country is relatively large & it is located in Asia",
    imageName: "vietnam-flag.png"
  },
  {
    latitude: 15.552727,
    longitude: 48.516388,
    name: "Yemen",
    hint: "This country is relatively large & it is located in the Middle East",
    imageName: "yemen-flag.png"
  },
  {
    latitude: -13.133897,
    longitude: 27.849332,
    name: "Zambia",
    hint: "This country is relatively large & it is located in Africa",
    imageName: "zambia-flag.png"
  },
  {
    latitude: -19.015438,
    longitude: 29.154857,
    name: "Zimbabwe",
    hint: "This country is relatively small & it is located in Africa",
    imageName: "zimbabwe-flag.png"
  },
]